<template>
    <section class="slice slice-trends-skills-index" :class="{'slice-trends-skills-index--grey': backgroundColor === 'grey'}">
        <div class="slice-content">
            <TitleBrand :field="props.slice.primary.title" />
            <div v-if="hasIndex1" class="index-panel index-panel--1">
                <PrismicImage v-for="(item, i) in props.slice.primary.index1" :key="`index1-${i}`" :field="item.image" :alt="`${item.image.alt}`" />
            </div>

            <br />
            <div v-if="hasIndex2" class="index-panel index-panel--2">
                <PrismicImage v-for="(item, i) in props.slice.primary.index2" :key="`index2-${i}`" :field="item.image" :alt="`${item.image.alt}`" />
            </div>
        </div>
    </section>
</template>

<script setup lang="ts">
    import {computed} from 'vue';
    import type {Content} from '@prismicio/client';

    import {getSliceComponentProps, PrismicImage} from '@prismicio/vue';
    import TitleBrand from '~/components/TitleBrand.vue';

    const props = defineProps(getSliceComponentProps<Content.TrendsSkillsIndexSlice>(['slice', 'index', 'slices', 'context']));
    const backgroundColor = computed(() => props.slice.primary.backgroundColor);

    const hasIndex1 = computed(
        () => props.slice.primary.index1.length > 0 && props.slice.primary.index1.filter((item) => !!item.image.url).length > 0,
    );
    const hasIndex2 = computed(
        () => props.slice.primary.index2.length > 0 && props.slice.primary.index2.filter((item) => !!item.image.url).length > 0,
    );
</script>

<style lang="scss">
    .slice-trends-skills-index {
        &--grey {
            background-color: var(--joy-color-neutral-20);
        }

        .index-panel {
            padding: var(--joy-core-spacing-4);
            display: grid;
            grid-template-columns: repeat(auto-fit, minmax(145px, 145px));
            justify-content: center;
            gap: var(--joy-core-spacing-4);
            border: var(--joy-core-spacing-1) solid var(--joy-color-neutral-50);
            background-color: var(--joy-color-background-default);
            width: 100%;
            border-radius: var(--joy-core-radius-4);

            &--1 {
                border-color: var(--joy-color-tertiary-50);
            }
            &--2 {
                border-color: var(--joy-color-brand-primary-70);
            }
            img {
                flex: 1;
                max-width: 130px;
            }
        }
    }
</style>
